<template>
  <b-row>
    <b-col md="12" class="text-right">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="success"
        class="mb-1 px-5"
        @click="exportPDF()"
      >
        Export PDF
      </b-button>
    </b-col>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col cols="12" md="12">
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Quotation Code </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ form.code }}
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Quotation Date </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ moment(form.created_at) }} WIB
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >Customer Informations</label
        >
        <b-row>
          <b-col md="3"> Customer </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{ customer.name }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Email </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{ customer.email }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Business Phone </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{
              customer.business_phone
            }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Fax </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{ customer.fax }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Website </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{ customer.website }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> PIC </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{ customer.pic }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Personal Phone </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder">{{
              customer.personal_phone
            }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Address </b-col>
          <b-col md="9">
            <span class="pr-2">:</span>
            <span class="font-weight-bolder"
              >{{ customer.address }}, {{ customer.city }},
              {{ customer.village }}, {{ customer.district }},
              {{ customer.province }}, {{ customer.country }},
              {{ customer.postal_code }}</span
            >
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >List Product</label
        >
        <b-row class="mb-1" v-for="(product, list) in products" :key="list">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" md="12">
                <b-img
                  thumbnail
                  fluid
                  :src="product.image"
                  width="150"
                  class="float-left mr-1"
                  style="height: 150px; object-fit: contain"
                />
                <b-row>
                  <b-col md="6">
                    <div class="mb-2 font-weight-bolder">
                      {{ product.code }}
                    </div>
                    <div class="text-success font-weight-bolder">
                      {{ product.name }}
                    </div>
                    <div>
                      {{ product.qty }} {{ product.unit }} X
                      {{ formatRupiah(product.price) }}
                    </div>
                  </b-col>
                  <b-col md="6" class="text-right mt-3">
                    <div>Subtotal Price</div>
                    <div class="font-weight-bolder">
                      {{ formatRupiah(product.total_price) }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col md="6" class="font-weight-bolder text-right">Total</b-col>
                    <b-col md="6" class="font-weight-bolder text-primary text-right"><span class="mr-1">{{ formatRupiah(form.purchase_price) }}</span></b-col>
                </b-row> -->
      </b-card>
      <!-- <b-card>
                <label class="font-weight-bolder text-primary mb-1" for="product">Delivery Informations</label>
                <b-row>
                    <b-col md="3">
                        Shipping Name
                    </b-col>
                    <b-col md="9">
                        <span class="pr-2">:</span> <span class="font-weight-bolder">JNE</span>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col md="3">
                        Shipping Cost
                    </b-col>
                    <b-col md="9">
                        <span class="pr-2">:</span> <span class="font-weight-bolder">{{ formatRupiah(form.shipping_cost) }}</span>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col md="3">
                        Address
                    </b-col>
                    <b-col md="9">
                        <span class="pr-2">:</span> <span class="font-weight-bolder">Jl sisingamangaraja X</span>
                    </b-col>
                </b-row>
            </b-card> -->

      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >Payment Details</label
        >
        <b-row>
          <b-col cols="6" md="3"> Purchase Price </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.purchase_price) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Shipping Cost </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.shipping_cost) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Tax </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.tax) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Discount </b-col>
          <b-col
            cols="6"
            md="9"
            class="text-right font-weight-bolder text-warning"
          >
            {{ "- " + formatRupiah(form.discount) }}
          </b-col>
        </b-row>
        <hr class="height-5" />
        <b-row>
          <b-col cols="6" md="3"> Total </b-col>
          <b-col
            cols="6"
            md="9"
            class="text-right font-weight-bolder text-success"
          >
            {{ formatRupiah(form.gross_price) }}
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BImg,
  BContainer,
  BBadge,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    ToastificationContent,
    BImg,
    BContainer,
    BBadge,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        created_at: "",
        purchase_price: null,
        shipping_cost: null,
        tax: null,
        discount: null,
        gross_price: null,
        customer_name: "",
        customer_id: null,
      },
      customer: {
        name: "",
        email: "",
        business_phone: null,
        fax: null,
        website: "",
        pic: "",
        personal_phone: null,
        address: "",
        city: "",
        village: "",
        district: "",
        province: "",
        country: "",
        postal_code: null,
      },
      permissions: [],
      products: [],
      url: "",
      errors: "",
      errMessage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getDetailsItem();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("sales/quotation/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.code = response.data.data.code;
        this.form.created_at = response.data.data.created_at;
        this.form.purchase_price = response.data.data.purchase_price;
        this.form.shipping_cost = response.data.data.shipping_cost;
        this.form.tax = response.data.data.tax;
        this.form.discount = response.data.data.discount;
        this.form.gross_price = response.data.data.gross_price;
        this.form.customer_name = response.data.data.customer_name;
        this.form.customer_id = response.data.data.customer_id;
        this.getCustomer();
      });
    },
    getDetailsItem() {
      const id = this.$route.params.id;
      this.$http.get("sales/quotation/" + id + "/items").then((response) => {
        // console.log(response.data.data)
        const { baseUrl } = $themeConfig.app;
        this.url = baseUrl;
        this.url += "storage/product/";

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            category: datas[i].category,
            code: datas[i].code,
            id: datas[i].id,
            image: this.url + datas[i].image,
            name: datas[i].name,
            price: datas[i].price,
            product_id: datas[i].product_id,
            qty: datas[i].qty,
            quotation_id: datas[i].quotation_id,
            total_price: datas[i].total_price,
            unit: datas[i].unit,
          };
          this.products.push($data);
        }
        // console.log(this.products)
      });
    },
    getCustomer() {
      this.$http
        .get("sales/customer/" + this.form.customer_id)
        .then((response) => {
          // console.log(response.data.data)
          this.customer.name = response.data.data.name;
          this.customer.email = response.data.data.email;
          this.customer.business_phone = response.data.data.business_phone;
          this.customer.fax = response.data.data.fax;
          this.customer.website = response.data.data.website;
          this.customer.pic = response.data.data.pic;
          this.customer.personal_phone = response.data.data.personal_phone;
          this.customer.address = response.data.data.address;
          this.customer.city = response.data.data.city;
          this.customer.village = response.data.data.village;
          this.customer.district = response.data.data.district;
          this.customer.province = response.data.data.province;
          this.customer.country = response.data.data.country;
          this.customer.postal_code = response.data.data.postal_code;
        });
    },
  },
};
</script>